import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  createThis2j2avj17cvnv2 as createThis,
  toString1pkumu07cwy4m as toString,
} from '../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { ensureNotNull1e947j3ixpazm as ensureNotNull } from '../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
} from '../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { SegmentPool_instanceistwsh6nfjqm as SegmentPool_instance } from './SegmentPool.mjs';
import { arrayCopytctsywo3h7gj as arrayCopy } from '../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        this.l3v_1 = 8192;
        this.m3v_1 = 1024;
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
function init_okio_Segment(_this__u8e3s4) {
  _this__u8e3s4.o3v_1 = 0;
  _this__u8e3s4.p3v_1 = 0;
  _this__u8e3s4.q3v_1 = false;
  _this__u8e3s4.r3v_1 = false;
  _this__u8e3s4.s3v_1 = null;
  _this__u8e3s4.t3v_1 = null;
}
var SegmentClass;
function Segment() {
  if (SegmentClass === VOID) {
    class $ {
      static u3v() {
        var $this = createThis(this);
        init_okio_Segment($this);
        $this.n3v_1 = new Int8Array(8192);
        $this.r3v_1 = true;
        $this.q3v_1 = false;
        return $this;
      }
      static v3v(data, pos, limit, shared, owner) {
        var $this = createThis(this);
        init_okio_Segment($this);
        $this.n3v_1 = data;
        $this.o3v_1 = pos;
        $this.p3v_1 = limit;
        $this.q3v_1 = shared;
        $this.r3v_1 = owner;
        return $this;
      }
      w3v() {
        this.q3v_1 = true;
        return Segment().v3v(this.n3v_1, this.o3v_1, this.p3v_1, true, false);
      }
      x3v() {
        var result = !(this.s3v_1 === this) ? this.s3v_1 : null;
        ensureNotNull(this.t3v_1).s3v_1 = this.s3v_1;
        ensureNotNull(this.s3v_1).t3v_1 = this.t3v_1;
        this.s3v_1 = null;
        this.t3v_1 = null;
        return result;
      }
      y3v(segment) {
        segment.t3v_1 = this;
        segment.s3v_1 = this.s3v_1;
        ensureNotNull(this.s3v_1).t3v_1 = segment;
        this.s3v_1 = segment;
        return segment;
      }
      z3v(byteCount) {
        // Inline function 'kotlin.require' call
        if (!(byteCount > 0 && byteCount <= (this.p3v_1 - this.o3v_1 | 0))) {
          var message = 'byteCount out of range';
          throw IllegalArgumentException().o2(toString(message));
        }
        var prefix;
        if (byteCount >= 1024) {
          prefix = this.w3v();
        } else {
          prefix = SegmentPool_instance.c3w();
          var tmp0 = this.n3v_1;
          var tmp2 = prefix.n3v_1;
          var tmp5 = this.o3v_1;
          // Inline function 'kotlin.collections.copyInto' call
          var endIndex = this.o3v_1 + byteCount | 0;
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          var tmp = tmp0;
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          arrayCopy(tmp, tmp2, 0, tmp5, endIndex);
        }
        prefix.p3v_1 = prefix.o3v_1 + byteCount | 0;
        this.o3v_1 = this.o3v_1 + byteCount | 0;
        ensureNotNull(this.t3v_1).y3v(prefix);
        return prefix;
      }
      d3w() {
        // Inline function 'kotlin.check' call
        if (!!(this.t3v_1 === this)) {
          var message = 'cannot compact';
          throw IllegalStateException().o(toString(message));
        }
        if (!ensureNotNull(this.t3v_1).r3v_1)
          return Unit_instance;
        var byteCount = this.p3v_1 - this.o3v_1 | 0;
        var availableByteCount = (8192 - ensureNotNull(this.t3v_1).p3v_1 | 0) + (ensureNotNull(this.t3v_1).q3v_1 ? 0 : ensureNotNull(this.t3v_1).o3v_1) | 0;
        if (byteCount > availableByteCount)
          return Unit_instance;
        this.e3w(ensureNotNull(this.t3v_1), byteCount);
        this.x3v();
        SegmentPool_instance.f3w(this);
      }
      e3w(sink, byteCount) {
        // Inline function 'kotlin.check' call
        if (!sink.r3v_1) {
          var message = 'only owner can write';
          throw IllegalStateException().o(toString(message));
        }
        if ((sink.p3v_1 + byteCount | 0) > 8192) {
          if (sink.q3v_1)
            throw IllegalArgumentException().ud();
          if (((sink.p3v_1 + byteCount | 0) - sink.o3v_1 | 0) > 8192)
            throw IllegalArgumentException().ud();
          var tmp0 = sink.n3v_1;
          var tmp2 = sink.n3v_1;
          var tmp5 = sink.o3v_1;
          // Inline function 'kotlin.collections.copyInto' call
          var endIndex = sink.p3v_1;
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          var tmp = tmp0;
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          arrayCopy(tmp, tmp2, 0, tmp5, endIndex);
          sink.p3v_1 = sink.p3v_1 - sink.o3v_1 | 0;
          sink.o3v_1 = 0;
        }
        var tmp0_0 = this.n3v_1;
        var tmp2_0 = sink.n3v_1;
        var tmp4 = sink.p3v_1;
        var tmp6 = this.o3v_1;
        // Inline function 'kotlin.collections.copyInto' call
        var endIndex_0 = this.o3v_1 + byteCount | 0;
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp_0 = tmp0_0;
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        arrayCopy(tmp_0, tmp2_0, tmp4, tmp6, endIndex_0);
        sink.p3v_1 = sink.p3v_1 + byteCount | 0;
        this.o3v_1 = this.o3v_1 + byteCount | 0;
      }
    }
    initMetadataForClass($, 'Segment', $.u3v);
    SegmentClass = $;
  }
  return SegmentClass;
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  Segment as Segmentnhwb43ukbiy3,
};
//endregion

//# sourceMappingURL=Segment.mjs.map
